const r = (g, e) => {
  let t = g.get(e);
  return t || (t = { entries: [], tag: { name: e } }, g.set(e, t)), t;
};
export {
  r as getTag
};
